import React, { Component } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import Cookies from 'universal-cookie';
import i18n from 'i18next';
import { getAwsApiBaseUrl } from '../../utils/awsApiBaseUrl';
import { userActions } from '../../actions';
import { storeLUCCredentials } from '../../services/user.service';
import { removeLocalStorageItem } from '../../utils/cookieAndLocalStorageUtils';
import { notify } from '../CommonNotification/CommonNotification';
import { history } from '../../history';
import { userConstants } from '../../constants';
import { Liveuloading } from '../Liveuloading';
import GoSolo from '../../assets/images/go-solo.png';

const LOGIN_REQUEST_TIMEOUT_MS = 30000;
const cookies = new Cookies();

// Mock Header to maintain design during AuthCallback without causing errors
const MockHeader = () => (
  <header>
    <div className='navbar d-flex flex-md-row flex-column align-items-end p-0'>
      <div className='logoMainCol'>
        <div className='navbar-header'>
          <img src={GoSolo} alt='GoSolo' className='logoMain' />
        </div>
      </div>
      <div className='navMainCol d-flex flex-column px-0'>
        <div
          className='d-flex flex-row align-items-md-end navsection'
          style={{ height: '54px' }}
        ></div>
      </div>
    </div>
  </header>
);

// Mock Footer to maintain design during AuthCallback
const MockFooter = () => (
  <footer
    className='d-flex px-2'
    style={{ minHeight: '40px', backgroundColor: '#000' }}
  >
    <div className='ml-auto'></div>
  </footer>
);

function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return (
    s4() +
    s4() +
    '-' +
    s4() +
    '-' +
    s4() +
    '-' +
    s4() +
    '-' +
    s4() +
    s4() +
    s4()
  );
}

class AuthCallbackComponent extends Component {
  componentDidMount() {
    this.authenticateWithCookies();
  }

  async authenticateWithCookies() {
    const { dispatch } = this.props;

    const isLocal =
      window.location.hostname === process.env.REACT_APP_LOCAL_HOSTNAME;
    const API_PATH = process.env.REACT_APP_AWSServerURL
      ? process.env.REACT_APP_AWSServerURL.replace(/^https?:\/\/[^/]+/, '')
      : '/v0_dev';
    const loginUrl = isLocal
      ? `/api-proxy${API_PATH}/awsluc/login` // proxied → same-origin, no CORS
      : `${getAwsApiBaseUrl()}/awsluc/login`; // direct → works on dev/prod

    // Generate user_session BEFORE the API call so it's available as x-user-uuid
    const d = new Date();
    d.setTime(d.getTime() + 1 * 24 * 60 * 60 * 1000);
    cookies.set('user_session', guid(), {
      path: '/',
      expires: d,
      secure: true,
    });

    try {
      const response = await axios.post(loginUrl, null, {
        headers: {
          Authorization: 'cookie regeneratetoken',
          'x-user-uuid': cookies.get('user_session'),
        },
        withCredentials: true,
        timeout: LOGIN_REQUEST_TIMEOUT_MS,
      });

      const credentials = response.data?.data?.credentials;
      if (!credentials?.access_token) {
        throw new Error('No access_token in login response');
      }

      if (credentials.user?.username) {
        cookies.set('username', credentials.user.username.toLowerCase(), {
          path: '/',
          expires: d,
          secure: true,
        });
      }

      // Mirror storeData: persist access_token + fetch inventory cookies
      await storeLUCCredentials(credentials.access_token);

      // Mirror userActions.login: dispatch LOGIN_SUCCESS + set admin_message_visible
      dispatch({ type: userConstants.LOGIN_SUCCESS });
      cookies.set('admin_message_visible', true, {
        path: '/',
        secure: true,
      });

      // Mirror userActions.login: fetch & dispatch user info, then validate type
      const userInfo = await dispatch(userActions.getUserInfo());
      if (userInfo?.type && userInfo.type !== 'luc_application') {
        notify('error', i18n.t('CONTACTSUPPORT'));
        removeLocalStorageItem('access_token');
        dispatch({ type: userConstants.LOGIN_FAILURE });
        history.push('/login');
        return;
      }

      history.push('/dashboard/units');
    } catch (error) {
      console.error('[AuthCallback] Login failed:', error?.message || error);
      history.push('/login');
    }
  }

  render() {
    return (
      <div
        id='wrapper'
        className='liveu_page'
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: '100vh',
          margin: '0 auto',
        }}
      >
        <MockHeader />
        <div id='page-wrapper' className='mainContentArea' style={{ flex: 1 }}>
          <Liveuloading />
        </div>
        <MockFooter />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({ dispatch });

export const AuthCallback = connect(
  null,
  mapDispatchToProps,
)(AuthCallbackComponent);
